import { render } from "./FreeClass.vue?vue&type=template&id=3c7f6063&scoped=true"
import script from "./FreeClass.vue?vue&type=script&lang=js"
export * from "./FreeClass.vue?vue&type=script&lang=js"

import "./FreeClass.vue?vue&type=style&index=0&id=3c7f6063&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7f6063"]])

export default __exports__